import * as Control$dMonad$dReader$dTrans from "../Control.Monad.Reader.Trans/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Specular$dInternal$dEffect from "../Specular.Internal.Effect/index.js";
const CleanupT = x => x;
const runCleanupT = dictMonadEffect => {
  const Monad0 = dictMonadEffect.Monad0();
  const bind = Monad0.Bind1().bind;
  const pure = Monad0.Applicative0().pure;
  return v => bind(dictMonadEffect.liftEffect(Specular$dInternal$dEffect.emptyDelayed))(actionsMutable => bind(v(actionsMutable))(result => bind(dictMonadEffect.liftEffect(Specular$dInternal$dEffect.unsafeFreezeDelayed(actionsMutable)))(actions => pure(Data$dTuple.$Tuple(
    result,
    Specular$dInternal$dEffect.sequenceEffects(actions)
  )))));
};
const onCleanup = dict => dict.onCleanup;
const monadTransCleanupT = {lift: dictMonad => x => v => x};
const monadEffectCleanupT = dictMonadEffect => Control$dMonad$dReader$dTrans.monadEffectReader(dictMonadEffect);
const monadCleanupT = dictMonad => Control$dMonad$dReader$dTrans.monadReaderT(dictMonad);
const monadCleanupReaderT = dictMonadCleanup => {
  const monadReaderT = Control$dMonad$dReader$dTrans.monadReaderT(dictMonadCleanup.Monad0());
  return {
    onCleanup: x => {
      const $0 = dictMonadCleanup.onCleanup(x);
      return v => $0;
    },
    Monad0: () => monadReaderT
  };
};
const monadCleanupCleanupT = dictMonadEffect => {
  const monadCleanupT1 = Control$dMonad$dReader$dTrans.monadReaderT(dictMonadEffect.Monad0());
  return {onCleanup: action => actions => dictMonadEffect.liftEffect(Specular$dInternal$dEffect.pushDelayed(actions)(action)), Monad0: () => monadCleanupT1};
};
const functorCleanupT = dictFunctor => (
  {
    map: x => {
      const $0 = dictFunctor.map(x);
      return v => x$1 => $0(v(x$1));
    }
  }
);
const execCleanupT = dictMonadEffect => {
  const $0 = dictMonadEffect.Monad0().Bind1().Apply0().Functor0().map(Data$dTuple.snd);
  const $1 = runCleanupT(dictMonadEffect);
  return x => $0($1(x));
};
const bindCleanupT = dictBind => Control$dMonad$dReader$dTrans.bindReaderT(dictBind);
const applyCleanupT = dictApply => {
  const $0 = dictApply.Functor0();
  const functorReaderT1 = {
    map: x => {
      const $1 = $0.map(x);
      return v => x$1 => $1(v(x$1));
    }
  };
  return {apply: v => v1 => r => dictApply.apply(v(r))(v1(r)), Functor0: () => functorReaderT1};
};
const applicativeCleanupT = dictApplicative => {
  const $0 = dictApplicative.Apply0();
  const $1 = $0.Functor0();
  const functorReaderT1 = {
    map: x => {
      const $2 = $1.map(x);
      return v => x$1 => $2(v(x$1));
    }
  };
  const applyReaderT1 = {apply: v => v1 => r => $0.apply(v(r))(v1(r)), Functor0: () => functorReaderT1};
  return {
    pure: x => {
      const $2 = dictApplicative.pure(x);
      return v => $2;
    },
    Apply0: () => applyReaderT1
  };
};
export {
  CleanupT,
  applicativeCleanupT,
  applyCleanupT,
  bindCleanupT,
  execCleanupT,
  functorCleanupT,
  monadCleanupCleanupT,
  monadCleanupReaderT,
  monadCleanupT,
  monadEffectCleanupT,
  monadTransCleanupT,
  onCleanup,
  runCleanupT
};
